<template>
  <div>
    <div v-if="true" class="row">
      <div class="col-12">
        <div class="">
          <draggable
            tag="div"
            @end="
              endSort($event);
              drag = false;
            "
            @start="drag = true"
            :move="draggableElements"
            v-bind="dragOptions"
            :list="ModuleArray"
          >
            <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
              class="master-container"
            >
              <div
                class="master-box"
                v-for="(Nav, index) in ModuleArray"
                :key="index + 'drag'"
              >
                <router-link :to="Nav.url" class="d-table">
                  <h4 class="d-flex justify-content-between">
                    <span>{{ $tc(Nav.name) }}</span>
                    <!-- <i
                      class="fa fa-ellipsis-v"
                      aria-hidden="true"
                      @click="changeBgColor"
                    ></i> -->
                  </h4>
                  <img
                    src="@/assets/img/icons/arrow-right.svg"
                    width="20"
                    height="20"
                    alt
                  />
                  <h4 class="specialText">{{
                    labelsObj[Nav.name] ? labelsObj[Nav.name] : ""
                  }}</h4>
                </router-link>
              </div>
            </transition-group>
          </draggable>
          <div v-if="ModuleArray.length == 0" class="w-100 mt-5">
            <p class="no-data text-center">No Favourite modules</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div></div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import Nav from "@/Nav";
  import { mapGetters, mapActions } from "vuex";
  import draggable from "vuedraggable";
  import MasterService from "@/services/MasterService";
  import MarketingService from "@/services/MarketingService";

  export default {
    components: {
      draggable,
    },
    data() {
      return {
        SideNav: Nav.items,
        ModuleArray: [],
        isEditable: true,
        list: [],
        drag: false,
        bgColor: "red",
        labelsObj: {},
      };
    },
    computed: {
      ...mapGetters(["getHotPickModules"]),
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost",
        };
      },
    },
    watch: {
      "$store.getters.getHotPickModules": function(newVal) {
        if (newVal) {
          this.SideNav.map((x) => {
            if (x.name != "Home") {
              this.checkArrayModuleNew(x);
            }
          });
        }
      },
    },
    beforeMount() {},
    mounted() {
      this.SideNav.map((x) => {
        if (x.name != "Home") {
          this.checkArrayModuleNew(x);
        }
      });
    },
    methods: {
      ...mapActions(["fetchUserHotPickModules"]),
      changeBgColor() {
        this.bgColor = "blue";
      },
      checkArrayModuleNew(x) {
        if (x.hasOwnProperty("children")) {
          x.children.map((y) => {
            if (y.hasOwnProperty("children")) {
              this.checkArrayModuleNew(y);
            } else {
              let checkModule = this.getHotPickModules.filter((z) => {
                return z.module_id == y.module_id;
              });
              if (checkModule.length > 0) {
                y["order"] = checkModule[0].order;
                y["hot_pick_id"] = checkModule[0].hot_pick_id;
                this.setExtraData(y);
                this.ModuleArray.push(y);
              }
            }
          });
        } else {
          let checkModule = this.getHotPickModules.filter((z) => {
            return z.module_id == x.module_id;
          });
          if (checkModule.length > 0) {
            x["order"] = checkModule[0].order;
            x["hot_pick_id"] = checkModule[0].hot_pick_id;
            this.setExtraData(x);
            this.ModuleArray.push(x);
          }
        }
        this.ModuleArray = _.sortBy(this.ModuleArray, (o) => o.order);
      },
      endSort(event) {
        this.ModuleArray.map((x, index) => {
          x["order"] = index + 1;
        });
        this.onChangeDrag();
      },
      draggableElements: function() {
        return this.isEditable;
      },
      onChangeDrag: _.debounce(function() {
        let favouriteOrder = [];
        this.ModuleArray.map((x) => {
          let Obj = {
            hot_pick_id: x.hot_pick_id,
            order: x.order,
            module_id: x.module_id,
          };
          favouriteOrder.push(Obj);
        });
        this.UpdateModuleOrder(favouriteOrder);
      }, 1 * 3500),

      UpdateModuleOrder: function(favouriteOrder) {
        // this.isEditable = false;
        let body = {
          favourites: favouriteOrder,
        };
        MasterService.updateModuleFavouriteOrder(body)
          .then((data) => {
            if (data && data.status) {
            }
          })
          .catch((error) => {
            console.error(error);
          });
      },
      async setExtraData(nav) {
        if (nav.name === "Website Cash Card Status") {
          return await this.getPendingCashCardCount(nav.name);
        }
      },
      async getPendingCashCardCount(name) {
        try {
          const response = await MarketingService.GetCashCardTransactionsCount({
            status: "Pending",
          });

          this.labelsObj[name] = response.data.data[0].count;

          this.$forceUpdate();
        } catch (error) {
          console.error("Error in getPendingCashCardCount ", error);
        }
      },
    },
  };
</script>
<style>
  .no-data {
    font-size: 15px;
  }

  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/HomeContainer/Home.vue